// react
import { useState, useEffect } from "react";
// common
import PageLayout from "../../../common/shell/PageLayout";
import TaskLayout from "../../../common/shell/TaskLayout";
// me
import { IRootViewModel, RootViewModel } from "./models/models";
import * as actions from "./actions";
import ListView from "./views/ListView";

export default function Controller() {
    // initial state
    const [vm, setVm] = useState<IRootViewModel>(new RootViewModel());

    // on mount
    useEffect(() => {
        actions.initialise("", setVm);
    }, []);

    function handleSearch(filter: string) {
        actions.initialise(filter, setVm);
    }

    return (
        <PageLayout title={["Licence Search"]}>
            <TaskLayout isBusy={vm.isBusy} error={vm.error}>
                <ListView key={vm.filter} filter={vm.filter} licences={vm.licences} onSearch={handleSearch} />
            </TaskLayout>
        </PageLayout>
    );
}
